var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInpur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_3222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.181 37.8092V37.8077H38.1903V24.0982C38.1903 17.3915 36.7465 12.2251 28.9058 12.2251C25.1365 12.2251 22.6071 14.2935 21.5744 16.2545H21.4654V12.8512H14.0312V37.8077H21.7722V25.4502C21.7722 22.1965 22.389 19.0502 26.4184 19.0502C30.3886 19.0502 30.4478 22.7634 30.4478 25.6589V37.8092H38.181Z",
    fill: "#6020BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42627 12.853H9.17659V37.8095H1.42627V12.853Z",
    fill: "#6020BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2984 0.428711C2.82035 0.428711 0.80957 2.43949 0.80957 4.91754C0.80957 7.39559 2.82035 9.44842 5.2984 9.44842C7.77644 9.44842 9.78723 7.39559 9.78723 4.91754C9.78567 2.43949 7.77489 0.428711 5.2984 0.428711V0.428711Z",
    fill: "#6020BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_3222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.381,
    height: 37.381,
    fill: "white",
    transform: "translate(0.80957 0.428711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInpur);
export default __webpack_public_path__ + "static/media/inpur.a1ccb9e6646ac5b49fd8544c9fb4cad7.svg";
export { ForwardRef as ReactComponent };